import LightTooltip from 'components/common/LightTooltip';

interface Props {
    documentName: string;
    currentGroup: {
        name: string;
    };
}

const GroupOnlyPermanentLabelRenderer = ({
    documentName,
    currentGroup,
}: Props) => {
    const label = `${currentGroup.name} - Group Only (No Expiry)`;
    const tooltip = `This ${documentName} is permanently restricted to the ${currentGroup.name} group`;

    return (
        <LightTooltip title={tooltip} placement="right" arrow>
            <div>{label}</div>
        </LightTooltip>
    );
};

export default GroupOnlyPermanentLabelRenderer;
